/**
 * @file お問い合わせフォームのバリデーション
 *
 */
'use strict';

/**
 * @classname FormValidateView
 * @classdesc お問い合わせフォームのバリデーション
 */
export default class FormValidateView {
	/**
	 * @constructor
	 * @param {jQuery} $e - 送信ボタン
	 */
	constructor($e) {
		console.log('FormValidateView.constructor');
		this._$e = $e;
		this._submit_state = true;
		this._$form = $('#form-contact');
		this._$your_name = $('#your-name');
		this._$your_name_kana = $('#your-name-kana');
		this._$your_address_prefecture = $('#your-address-prefecture');
		this._$your_address_detail = $('#your-address-detail');
		this._$your_telephone = $('#your-telephone');
		this._$your_email = $('#your-email');
		this._$your_message = $('#your-message');
		this._$e.on('click', () => this.onClick());
		this.formInit();
	};

	/**
	 * 送信ボタンクリックイベントのコールバック
	 *
	 * @memberof FormValidateView
	 * @return {undefined}
	 */
	formInit() {
		console.log('FormValidateView.formInit')
		this._$form.attr('action', '/contact/contact_complete/');
		this._$your_name.on('blur', () => this.checkYourName());
		this._$your_name_kana.on('blur', () => this.checkYourNameKana());
		this._$your_address_prefecture.on('blur', () => this.checkEmpty(this._$your_address_prefecture));
		this._$your_address_detail.on('blur', () => this.checkEmpty(this._$your_address_detail));
		this._$your_telephone.on('blur', () => this.checkYourTelephone());
		this._$your_email.on('blur', () => this.checkYourEmail());
		this._$your_message.on('blur', () => this.checkYourMessage());
	}

	/**
	 * 送信ボタンクリックのコールバック
	 *
	 * @memberof FormValidateView
	 * @return {undefined}
	 */
	onClick() {
		console.log('FormValidateView.onClick');
		this._submit_state = true;
		let checkAll = new Promise((resolve, reject) => {
			this.checkYourName();
			this.checkYourNameKana();
			this.checkEmpty(this._$your_address_prefecture);
			this.checkEmpty(this._$your_address_detail);
			this.checkYourTelephone();
			this.checkYourEmail();
			this.checkYourMessage();
			resolve();
		});
		checkAll.then(() => {
			console.log(this._submit_state)
			if(this._submit_state) this._$form.trigger('submit');
			this._submit_state = true;
		});
	}

	/**
	 * バリデーション - お名前
	 *
	 * @memberof FormValidateView
	 * @return {undefined}
	 */
	checkYourName() {
		console.log('FormValidateView.checkYourName');
		if(!this._$your_name.val()) {
			this.showErrorTip(this._$your_name, '入力してください');
		} else {
			this.hideErrorTip(this._$your_name);
		}
	}

	/**
	 * バリデーション - ふりがな
	 *
	 * @memberof FormValidateView
	 * @return {undefined}
	 */
	checkYourNameKana() {
		console.log('FormValidateView.checkYourNameKana');
		if(!this._$your_name_kana.val()) {
			this.showErrorTip(this._$your_name_kana, '入力してください');
		} else {
			if(!this._$your_name_kana.val().match(/^[ぁ-んー　]*$/)){
				this.showErrorTip(this._$your_name_kana, 'ひらがなで入力してください');
			} else {
				this.hideErrorTip(this._$your_name_kana);
			}
		}
	}

	/**
	 * バリデーション - 電話番号
	 *
	 * @memberof FormEntryValidateView
	 * @return {undefined}
	 */
	 checkYourTelephone() {
		console.log('FormEntryValidateView.checkYourTelephone');
		const regexp_num = /^[0-9]+$/;
		if(!this._$your_telephone.val()) {
			this.showErrorTip(this._$your_telephone, '入力してください');
		} else {
			if(!regexp_num.test(this._$your_telephone.val())){
				this.showErrorTip(this._$your_telephone, '半角数字のみで入力してください');
			} else {
				this.hideErrorTip(this._$your_telephone);
			}
		}
	}

	/**
	 * バリデーション - メールアドレス
	 *
	 * @memberof FormValidateView
	 * @return {undefined}
	 */
	checkYourEmail() {
		console.log('FormValidateView.checkYourEmail');
		if(!this._$your_email.val()) {
			this.showErrorTip(this._$your_email, '入力してください');
		} else {
			if(!this._$your_email.val().match(/^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i)){
				this.showErrorTip(this._$your_email, 'メールアドレスが不正です');
			} else {
				this.hideErrorTip(this._$your_email);
			}
		}
	}

	/**
	 * バリデーション - メッセージ
	 *
	 * @memberof FormValidateView
	 * @return {undefined}
	 */
	checkYourMessage() {
		console.log('FormValidateView.checkYourMessage');
		if(!this._$your_message.val()) {
			this.showErrorTip(this._$your_message, '入力してください');
		} else {
			this.hideErrorTip(this._$your_message);
		}
	}

	/**
	 * バリデーション - 共通：エンプティ
	 *
	 * @memberof FormEntryValidateView
	 * @return {undefined}
	 */
	 checkEmpty(__$e, select = false) {
		if(!__$e.val()) {
			this.showErrorTip(__$e, select ? '選択してください' : '入力してください');
		} else {
			this.hideErrorTip(__$e);
		}
	}

	/**
	 * error-tip表示
	 *
	 * @memberof FormValidateView
	 * @return {undefined}
	 */
	showErrorTip($form_parts, error_text) {
		$form_parts.closest('dl').find('.error-tip').addClass('show');
		$form_parts.closest('dl').find('.error-tip-inner').text(error_text);
		this._submit_state = false;
	}

	/**
	 * error-tip非表示
	 *
	 * @memberof FormValidateView
	 * @return {undefined}
	 */
	hideErrorTip($form_parts) {
		$form_parts.closest('dl').find('.error-tip').removeClass('show');
		$form_parts.closest('dl').find('.error-tip-inner').text('');
	}

}
